import React, { FC, memo } from 'react'
import { Link, useRouterState } from '@tanstack/react-router'
import cn from 'classnames'
import { useActions } from 'hooks/useActions'

import { MENU_LINKS } from './constants'
import { HeaderNavigationProps } from './types'

import s from './Header.module.less'

const HeaderNavigation: FC<HeaderNavigationProps> = (props) => {
  const { isModalNotifications, totalNotification, handleOpenModalNotifications } = props
  const {
    location: { pathname }
  } = useRouterState()
  const { closeMobileSidebar } = useActions()

  const handleClose = () => {
    closeMobileSidebar()
  }

  return (
    <div className={s.navigation}>
      {MENU_LINKS.map(({ title, link }, index) => (
        <Link
          key={index}
          className={cn(s.item, { [s.itemIsActive]: pathname.includes(link) })}
          onClick={handleClose}
          to={link}
        >
          {title}
        </Link>
      ))}
      <div
        className={cn(s.item, s.itemNotification, { [s.itemIsActive]: isModalNotifications })}
        onClick={() => {
          handleOpenModalNotifications && handleOpenModalNotifications()
          handleClose()
        }}
      >
        Уведомления
        {/* @ts-ignore */}
        {totalNotification > 0 && <div className={s.totalNotification}>{totalNotification}</div>}
      </div>
    </div>
  )
}

export default memo(HeaderNavigation)
